import { ResponseHonbuSetting, ResponseHonbuSettingItem } from '@/repositories/fuzoku-meisai/junsoku/data'
import { Axios } from 'axios'
import { RootState } from '@/store'

export interface HonbuhiRepository {
  list (): Promise<ResponseHonbuSetting>;

  save (param: ResponseHonbuSettingItem[]): Promise<ResponseHonbuSetting>;
}

export class HonbuhiRepositoryImpl implements HonbuhiRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/honbuhi`
    this.state = state
  }

  private readonly http: Axios
  private readonly baseUrl: string
  private readonly state: RootState

  async list (): Promise<ResponseHonbuSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (param: ResponseHonbuSettingItem[]): Promise<ResponseHonbuSetting> {
    const { data } = await this.http.post(this.baseUrl, param)
    return data
  }
}
